export const HAPPINESS = 'happiness'
export const REPLETE = 'replete'
export const LOVE = 'love'

export const states = [HAPPINESS, REPLETE, LOVE]